export const BrandingLogoSizes = {
    Halftone: 'Halftone',
    Large: 'Large',
    Medium: 'Medium',
    Small: 'Small',
    XSmall: 'XSmall',
    XXSmall: 'XXSmall',
};
